import { f as fail } from "../../../../chunks/index.js";
const actions = {
  // /api/address/:addressUuid, /api/employee/:employeeUUID
  update_employee_status: async ({ request, locals, fetch, params }) => {
    const data = await request.formData();
    const status = data.get("status");
    try {
      const response = await fetch(`$api/employee/${params.uuid}`, {
        method: "PUT",
        headers: locals.fetchAuthHeaders,
        body: JSON.stringify({
          employmentStatus: status
        })
      });
      const employee_status_data = await response.text();
      if (response.ok) {
        return employee_status_data;
      }
    } catch (e) {
      console.error("Error updating employee status", e);
    }
    return fail(400, {
      message: "Failed to update employee status",
      message_status: "failed"
    });
  }
};
export {
  actions
};
//# sourceMappingURL=_page.server.ts.js.map
